export default __webpack_public_path__ + "static/media/parchmentFade.f20d3934.png";